module.exports = __webpack_public_path__ + "static/media/4_detali_two_0_69.26.5a453cec.png";